import { type ScopeDescriptor } from '../../components/ScopedBlock/models'

export interface SettingsEntry {
  // Doubles as the React key and the menu-item tracking key
  key: string
  to: string
  label: string
  icon: string
  scope?: ScopeDescriptor
}

// Route, label, icon, tracking key and scope of every Settings destination in one place, so the
// desktop popover, the mobile menu and the trigger's active state cannot drift apart
export const SETTINGS_ENTRIES: SettingsEntry[] = [
  { key: 'setup', to: '/workspace/setup', label: 'Setup', icon: 'bi-sliders' },
  { key: 'manageTeam', to: '/account/manage-team', label: 'Team', icon: 'bi-diagram-3' },
  {
    key: 'plan',
    to: '/account/plan',
    label: 'Plan',
    icon: 'bi-credit-card-2-back',
    scope: { scope: 'billing_subscription:change', superScope: ['billing_subscription:admin'] },
  },
]

export const isSettingsRouteActive = (pathname: string) => SETTINGS_ENTRIES.some(({ to }) => pathname === to || pathname.startsWith(`${to}/`))
